import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/belepes',
      name: 'login',
      component: () => import('./views/Login.vue')
    },
    {
      path: '/elfelejtett-jelszo',
      name: 'forgottenPassword',
      props: true,
      component: () => import('./views/ForgottenPassword.vue')
    },
    {
      path: '/tomeges-feltoltes',
      name: 'bulkUpload',
      component: () => import('./views/BulkUpload.vue'),
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/bekuldes',
      name: 'formUpload',
      component: () => import('./views/FormUpload.vue'),
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/lekerdezes',
      name: 'report',
      component: () => import('./views/Report.vue'),
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/statisztika',
      name: 'statistics',
      component: () => import('./views/Statistics.vue')
    },
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem('user', null) === null) {
      next({
        path: '/belepes'
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router